import { AxiosResponse } from 'axios';
import { api } from '../base';
import { PartCatalogDetailRequest, PartCatalogRequest } from '@/main/models/request';
import { Result } from '@/main/models/common/resultResponse';
import { PaginationResponse } from '@/main/models/common/paginationResponse';
import { PartCatalogDetailResponse, PartCatalogResponse, PartCatalogSuggestionResponse } from '@/main/models/response/partCatalogResponse';
import { IPartCatalogApi } from '../base/registration/partCatalogApi';

const baseRoute: string = 'PartCatalog';

export class PartCatalogApi extends IPartCatalogApi {
  searchgrid(request: PartCatalogRequest): Promise<AxiosResponse<PaginationResponse<PartCatalogResponse>>> {
    return api.get(`${baseRoute}/searchgrid`, { params: request });
  }

  detail(request: PartCatalogDetailRequest): Promise<AxiosResponse<Result<PartCatalogDetailResponse>>> {
    return api.get(`${baseRoute}/detail`, { params: request });
  }

  getSuggestion(partNumber: string): Promise<AxiosResponse<Result<PartCatalogSuggestionResponse>>> {
    return api.get(`${baseRoute}/getsuggestion`, { params: { partNumber } });
  }
}


